import { Component, OnInit } from '@angular/core';
import { mergeMap } from 'rxjs/operators';
import { GetEmpty } from 'src/app/classes/Empties';
import { NumeroALetras } from 'src/app/classes/NumeroALetras';
import { OrderInfo, OrderItemInfo } from 'src/app/models/models';
import { BaseComponent } from '../base/base.component';

@Component({
	selector: 'app-print-funeraria',
	templateUrl: './print-funeraria.component.html',
	styleUrls: ['./print-funeraria.component.css']
})
export class PrintFunerariaComponent extends BaseComponent implements OnInit
{
	order_info: OrderInfo = GetEmpty.orderInfo(this.rest);
	total_letra: string = '';
	iva_letra: string = '';
	subtotal_letra: string = '';

	/** Items con cargo (precio > 0) — aparecen con su importe */
	items_con_precio: OrderItemInfo[] = [];

	/** Items sin cargo (precio = 0) — aparecen como "INCLUIDO" */
	items_incluidos: OrderItemInfo[] = [];

	private _nl = new NumeroALetras('', '', '/100', '/100');

	ngOnInit(): void
	{
		this.subs.sink = this.route.paramMap.pipe
		(
			mergeMap((params) => this.rest.order_info.get(params.get('id')))
		)
		.subscribe
		({
			next: (order_info) =>
			{
				this.order_info = order_info;

				this.items_con_precio = order_info.items.filter(
					(oi) => (oi.order_item.total ?? 0) > 0
				);

				this.items_incluidos = order_info.items.filter(
					(oi) => (oi.order_item.total ?? 0) === 0
				);

				this.total_letra    = this._nl.numeroALetras(order_info.order.total    ?? 0);
				this.iva_letra      = this._nl.numeroALetras(order_info.order.tax      ?? 0);
				this.subtotal_letra = this._nl.numeroALetras(order_info.order.subtotal ?? 0);
			},
			error: (error) => this.showError(error)
		});
	}

	printDirect()
	{
		window.print();
	}
}
